module.exports = __webpack_public_path__ + "img/noTypingTest.45059790.svg";